import "../styles/RegistrationStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import StepperForm from "../components/StepperFormComponent";
import RightSide from ".././.././../assets/images/RightSide.png";
import ".././.././../styles/CommonStyles.css";
import { MultiStepProvider } from "../components/ContextApiComponent";

function Signup() {
  return (
    <div className="v2-login-form-wrapper">
      <h1 className="v2-login-heading" >Create an account</h1>
                    <p style={{color:"#64748b",fontSize:"14px",fontWeight:"500",textAlign: "center"
}}>Create an account to begin learning</p>

      <div >
        <MultiStepProvider>
          <StepperForm />
        </MultiStepProvider>
      </div>
      <div className="image-container1">
        <img src={RightSide} alt="logo" className="img-fluid bottom-image" />
      </div>
    </div>
  );
}

export default Signup;
